import PropTypes from 'prop-types';
// @mui
import { TableRow, TableCell, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTypography = styled(Typography)(({ theme }) => ({
  '&': {
    color: 'black',
    fontSize: '13px',
    fontWeight: 400,
  },
}));

// ----------------------------------------------------------------------

TierTableRow.propTypes = {
  row: PropTypes.object,
};

export default function TierTableRow({ row }) {
  const { tier, cnt, commission, profit } = row;

  return (
    <TableRow hover>
      <TableCell>
        <StyledTypography
          sx={{
            color: '#FF9D00 !important',
          }}
        >
          {tier || '-'}
        </StyledTypography>
      </TableCell>

      <TableCell>
        <StyledTypography
          sx={{
            color: '#FF9D00 !important',
          }}
        >
          {commission || '-'}
        </StyledTypography>
      </TableCell>

      <TableCell>
        <StyledTypography
          sx={{
            color: '#FF9D00 !important',
          }}
        >
          {cnt || '-'}
        </StyledTypography>
      </TableCell>

      <TableCell>
        <StyledTypography
          sx={{
            color: '#FF9D00 !important',
          }}
        >
          {profit || '-'}
        </StyledTypography>
      </TableCell>
    </TableRow>
  );
}
